<!-- eslint-disable no-mixed-spaces-and-tabs -->
<template>
	<div>
		<BreadCrumbsWithButtons
			:buttons="buttons"
			:pdfOptions="pdfOptions.ipa" />
		<a href="#" :id="sidebarLinks[0].id" :ref="sidebarLinks[0].id"></a>
		<!-- PDF SUB-OFFERS MENU -->
		<v-dialog
			transition="dialog-bottom-transition"
			v-model="showSubofferMenu"
			max-width="500"
			scrollable
			@update:model-value="
				v => {
					if (!v) resetPdfSelection();
				}
			">
			<v-card variant="elevated" class="mt-4" style="max-height: 65vh">
				<!-- Header -->
				<v-toolbar>
					<v-toolbar-title
						:class="
							$vuetify.display.smAndDown
								? 'text-body-2'
								: 'text-h6'
						">
						Generare PDF pentru ofertă - #{{ offer?.id }}
					</v-toolbar-title>
				</v-toolbar>

				<!-- Suboffers list -->
				<v-card-text scrollable style="max-height: 500px">
					<v-list density="compact">
						<!-- <div class="d-flex justify-space-between py-1 pl-4">
                            <v-btn
                                variant="elevated"
                                @click="toggleSelectAllSuboffers"
                                >selecteaza toate subofertele</v-btn
                            >
                        </div> -->

						<!-- TOTAL -->
						<v-list-item class="py-1" @click="toggleTotal">
							<template #prepend>
								<v-checkbox
									v-model="selectTotal"
									density="compact"
									color="secondary"
									class="mr-2"
									hide-details
									@click.stop="toggleTotal" />
							</template>
							<v-list-item-title
								>Generează OFERTA TOTALĂ</v-list-item-title
							>
						</v-list-item>

						<!-- SUBOFFERS -->
						<v-list-item
							v-for="sub in pdfSuboffers || []"
							:key="sub.id"
							class="py-1"
							@click="toggleSingleSuboffer(sub.id)">
							<template #prepend>
								<v-radio
									:model-value="
										selectedSuboffers[0] === sub.id
									"
									density="compact"
									color="secondary"
									class="mr-2"
									hide-details
									@click.stop="
										toggleSingleSuboffer(sub.id)
									" />
							</template>

							<v-list-item-title
								class="d-flex align-center gap-2">
								Subofertă {{ sub.id }}
								<span class="text-caption">
									• Unitate:
									<strong>{{ getUnitLabel(sub) }}</strong>
								</span>
							</v-list-item-title>
						</v-list-item>
					</v-list>
				</v-card-text>

				<v-card-actions class="d-flex justify-space-between pa-4">
					<v-btn text @click="resetPdfSelection">Închide</v-btn>

					<v-btn
						color="#54c5b0"
						variant="elevated"
						:disabled="
							!selectTotal && selectedSuboffers.length === 0
						"
						@click="generatePDFClicked">
						Generează PDF-uri
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<OfferInformation
			v-if="client && location"
			:client="client"
			:location="location"
			:offer="offer"
			:offerId="offerId"
			@update="updateOfferData"
			@offer-buttons-in-view="isOfferButtonsInView = $event" />
		<a href="#" :id="sidebarLinks[1].id" :ref="sidebarLinks[1].id"></a>

		<v-btn
			color="secondary"
			v-if="isDebug"
			class="ml-2"
			@click="randomizeUnitAndInsulation">
			Randomize unit config + insulations
		</v-btn>
		<RoomsDetailsIPA
			ref="roomsDetails"
			v-if="location"
			:location="location"
			:floorGroups="floorGroups"
			:floors="floors"
			:show-apartments="showApartments"
			:insulation-subtype="insulationSubtype"
			@update:showApartments="showApartments = $event"
			@save-location="verifyIpaLocation($event)"
			@update-location="getLocationChanges"
			:auto-check-apartments="
				location?.compartmentation === 2 ||
				location?.customization === 2
			"
			@recalc-needed="markRecalcOnly"
			@mark-location-changed="markLocationChanged" />
		<a href="#" :id="sidebarLinks[2].id" :ref="sidebarLinks[2].id"></a>

		<ProductDetailsForm
			v-if="location"
			v-model="productDetailsData"
			:location="location"
			:insulation-types="insulationTypes"
			:additional-insulation-types="additionalInsulationTypes"
			:tackerFoilTypes="tackerFoilTypes"
			:show-total-products="showTotalProducts"
			:show-apartments="showApartments"
			:offer-type="offerType"
			@update-compartmentation="updateCompartmentation"
			@update-customization="updateCustomization"
			@update:show-total-products="showTotalProducts = $event"
			@changed="markLocationChanged" />

		<a href="#" :id="sidebarLinks[3].id" :ref="sidebarLinks[3].id"></a>

		<v-card class="mt-2">
			<v-toolbar>
				<v-toolbar-title
					:class="
						$vuetify.display.mdAndUp ? 'text-h6' : 'text-subtitle-1'
					">
					Produse
				</v-toolbar-title>
				<template v-if="$vuetify.display.mdAndUp">
					<v-select
						v-model="compartmentationValue"
						:items="compartmentationOptionsFiltered"
						item-value="value"
						item-title="label"
						label="Compartimentare"
						density="compact"
						variant="outlined"
						hide-details
						class="mr-6"
						style="max-width: 300px; min-width: 200px"
						:dirty="false" />
				</template>
				<template v-else>
					<v-btn icon variant="text" title="Schimbă compartimentarea">
						<v-icon>mdi-view-grid-outline</v-icon>
						<v-menu activator="parent">
							<v-list>
								<v-list-item
									v-for="item in compartmentationOptionsFiltered"
									:key="item.value"
									@click="compartmentationValue = item.value"
									:active="
										compartmentationValue === item.value
									">
									<v-list-item-title>{{
										item.label
									}}</v-list-item-title>
								</v-list-item>
							</v-list>
						</v-menu>
					</v-btn>
				</template>
			</v-toolbar>

			<v-card-text class="pa-0">
				<a
					href="#"
					:id="sidebarLinks[4].id"
					:ref="sidebarLinks[4].id"></a>
				<ProductTable
					v-if="
						loadProductTable &&
						location &&
						(location.compartmentation === 0 || showTotalProducts)
					"
					:is-whole-location="isWholeLocation"
					:offered-products="normalizedOfferedProducts"
					:offer="offer"
					:offer-type="offerType"
					:headers="productTableHeaders"
					:special-products="specialProducts"
					@update-products="updateOfferProducts"
					@update-offer="updateOfferData"
					@selected-price-list="updateOfferPriceList"
					:price-list-type="
						this.$store.state.PRICE_LIST_TYPES.GENERAL.value
					"
					:disableDynamicHeight="true"
					ref="productTableGlobal" />

				<!-- For each level/apartament -->
				<div
					class="mt-2"
					v-else-if="
						loadProductTable &&
						location &&
						!showTotalProducts &&
						(location.compartmentation === 1 ||
							location.compartmentation === 2)
					">
					<div
						v-for="unitId in getUnitIds()"
						:key="unitId"
						class="mb-2">
						<ProductTable
							ref="productTables"
							:custom-title="getUnitTitle(unitId)"
							:collapsible="true"
							:offered-products="productsByUnit[unitId] ?? []"
							:offer="offer"
							:offer-type="offerType"
							:headers="productTableHeaders"
							:special-products="
								specialProductsByUnit &&
								specialProductsByUnit[unitId]
									? specialProductsByUnit[unitId]
									: []
							"
							@update-products="
								updateUnitProducts($event, unitId)
							"
							@update-offer="updateOfferData"
							@selected-price-list="updateOfferPriceList"
							:price-list-type="
								$store.state.PRICE_LIST_TYPES.GENERAL.value
							"
							:disableDynamicHeight="true" />
					</div>
				</div>
			</v-card-text>
		</v-card>

		<a href="#" :id="sidebarLinks[3].id" :ref="sidebarLinks[3].id"></a>
		<OfferPaymentTerms
			:offer="offer"
			@update_payment_terms="updatePaymentTerms" />
	</div>
</template>

<script>
import navMixin from "@/mixins/navMixin";
import offerMixin from "@/mixins/offerMixin";
import ProductTable from "@/components/offer/ProductTable.vue";
import OfferInformation from "@/components/offer/OfferInformation.vue";
import OfferPaymentTerms from "@/components/offer/OfferPaymentTerms.vue";
import BreadCrumbsWithButtons from "@/components/common/BreadCrumbsWithButtons.vue";
import RoomsDetailsIPA from "@/components/offer/RoomsDetailsIPA.vue";
import apiClient from "@/utils/apiClient";
import {
	showAlertModal,
	createPDFOffer,
	createPDFCompositeOffer,
	createPDFCompositeTotalOffer,
} from "@/utils/utils";
import ProductDetailsForm from "@/components/offer/ProductDetailsForm.vue";
import {
	IPA_PRODUCT_TYPES,
	INSULATION_VARIANTS,
	GROOVED_PANEL_SIZE,
	TACKER_PANEL_SIZE,
} from "@/IPA/IPAProducts";

import {
	INSULATION_TYPES,
	ADDITIONAL_INSULATION_TYPES,
	TACKER_FOIL_TYPES,
} from "@/IPA/InsulationChoices.js";
import { FLOOR_MAP } from "@/IPA/Floors";
import { APARTMENT_MAP } from "@/IPA/Apartments";
import {
	ipa_products,
	RECOMMENDED_THERMOSTAT_PRODUCT_CODES,
} from "@/IPA/IPAProducts";
import { deriveIpaSelections } from "@/IPA/IPAHelpers";
import {
	createBoxesRequirements,
	calcIpaRequirements,
	roundRequirements,
} from "@/IPA/ipaCalculator";
import emitter from "@/utils/emitter";

import { COMPARTMENTATION_OPTIONS } from "@/IPA/Compartimentation";

import {
	PIPE_CHOICES,
	DISTRIBUTION_CHOICES,
	BOX_FOR_DISTRIBUTION_CHOICES,
	AUTOMATION_CHOICES,
	NO_YES_CHOICES,
	TEMPERATURE_CONTROL_CHOICES,
} from "@/IPA/ProductChoices.js";
import { getUnitId } from "@/utils/apartmentUtils";

export default {
	name: "OfferIPA",
	mixins: [navMixin, offerMixin],
	components: {
		RoomsDetailsIPA,
		BreadCrumbsWithButtons,
		OfferInformation,
		ProductTable,
		OfferPaymentTerms,
		ProductDetailsForm,
	},
	data() {
		return {
			selectTotal: false,
			selectedSuboffers: [],
			showSubofferMenu: false,
			triedCalc: false,
			hasCalculatedProducts: false,
			needRecalc: false,
			showApartments: false,
			showTotalProducts: false,
			openPanels: [],
			isDebug: false,
			isSaveOfferClicked: false,
			createNewOfferClicked: false,
			initialLocation: null,
			productRoomMap: new Map(),
			savedLocation: false,
			productDetailsData: {},
			compartmentationOptions: COMPARTMENTATION_OPTIONS,
			requirementsObj: {
				requirements: [], // combined & deduped
				byUnit: {}, // per-unit raw lists
			},
			resultedProducts: [],
			finalResultedProducts: [],
			recommendedProducts: [],
			floors: [],
			insulationTypes: INSULATION_TYPES,
			additionalInsulationTypes: ADDITIONAL_INSULATION_TYPES,
			tackerFoilTypes: TACKER_FOIL_TYPES,
			location: null,
			client: null,
			offer: null,
			offeredProducts: [],
			specialProducts: [],
			/** Per-unit recommended product codes when compartmentation 1 or 2 (e.g. floor automation differs). */
			recommendedProductsByUnit: {},
			/** Per-unit special product rows when compartmentation 1 or 2. */
			specialProductsByUnit: {},
			ipaProducts: ipa_products,
			floorGroups: [],
			loadProductTable: false,
			productTableHeaders: [
				{
					title: "Nr.",
					key: "number",
					align: "center",
					show: false,
					width: "70px",
				},
				{
					title: "Cod articol",
					key: "product_code",
					align: "center",
					show: true,
					width: "140px",
				},
				{
					title: "Nume articol",
					key: "product_name",
					align: "start",
					show: true,
				},
				{
					title: "Categorie",
					key: "assigned_sub_category",
					align: "center",
					show: true,
				},
				{
					title: "Cantitate",
					key: "quantity",
					align: "center",
					show: true,
					width: "130px",
				},
				{
					title: "UM",
					key: "measurement_unit",
					align: "center",
					show: true,
					width: "70px",
				},
				{
					title: "Preț listă cu TVA",
					key: "price",
					align: "end",
					show: true,
				},
				{
					title: "Discount",
					key: "discount",
					align: "center",
					show: true,
					width: "120px",
				},
				{
					title: "Preț final cu TVA",
					key: "final_price",
					align: "end",
					show: true,
				},
				{
					title: "Valoare finală cu TVA",
					key: "final_total_price",
					align: "end",
					show: true,
				},
			],

			sidebarLinks: [
				{
					name: "Informații",
					link: "#section1",
					id: "section1",
				},
				{
					name: "Detalii Camere",
					link: "#section2",
					id: "section2",
				},
				{
					name: "Detalii Produse",
					link: "#section3",
					id: "section3",
				},
				{
					name: "Produse",
					link: "#section4",
					id: "section4",
				},
				{
					name: "Termeni de plată",
					link: "#section5",
					id: "section5",
				},
			],
			recommendedProductAdded: false,

			offerType: { type: "IPA", productCategories: ["IPA"] },
		};
	},
	async created() {
		this.locationId = this.$route.params.locationId;
		await this.getRecommendedProducts(this.offerType.type);
		const priceListItems = await this.fetchPriceListProducts();
		this.products = this.reassignSubCategories(
			this.setZeroQtyForBackendProducts(priceListItems.items)
		);
		this.productsFetched = true;
		// Populate specialProducts with recommended products from backend (if offer was loaded)
		// This ensures recommended products appear after save/reload (flat list or per-unit when comp 1/2)
		const hasFlatRecommended =
			this.recommendedProducts && this.recommendedProducts.length > 0;
		const comp = this.location?.compartmentation ?? 0;
		const hasPerUnitRecommended =
			(comp === 1 || comp === 2) &&
			this.recommendedProductsByUnit &&
			Object.keys(this.recommendedProductsByUnit).some(
				key =>
					Array.isArray(this.recommendedProductsByUnit[key]) &&
					this.recommendedProductsByUnit[key].length > 0
			);
		if ((hasFlatRecommended || hasPerUnitRecommended) && this.products) {
			this.populateSpecialProductsFromRecommended();
		}
		this.loadProductTable = true;
	},
	mounted() {
		this.$store.state.sidebarLinks = this.sidebarLinks;
		if (this.location) {
			this.location.compartmentation = Number(
				this.location.compartmentation ?? 0
			);
			this.location.customization = Number(
				this.location.customization ?? 0
			);
		}
	},
	computed: {
		isAllSelected() {
			return (
				this.selectedSuboffers.length === this.pdfSuboffers.length &&
				this.pdfSuboffers.length > 0
			);
		},
		insulationSubtype() {
			const result = {};
			const custType = Number(this.location?.customization ?? 0);
			const root = this.productDetailsData || {};

			// Helper to extract subtype from insulation object
			const extractSubtype = insType => {
				if (!insType) return null;
				return (
					Number(
						insType?.subtype ?? insType?.value?.subtype ?? insType
					) || null
				);
			};

			// Customization 0: whole location
			if (custType === 0) {
				const cfg = this.getUnitConfig(
					0,
					this.location.compartmentation,
					this.location.customization
				);
				const insType = cfg?.insulationType ?? cfg?.insulation_type;
				result[0] = extractSubtype(insType);
				return result;
			}

			// Customization 1 (per floor) or 2 (per apartment)
			const byType = root[custType] || {};
			for (const unitKey of Object.keys(byType)) {
				const unitData = byType[unitKey] || {};
				const insType =
					unitData.insulationType ?? unitData.insulation_type;
				result[unitKey] = extractSubtype(insType);
			}

			return result;
		},
		pdfSuboffers() {
			if (!this.offer?.offers || !this.offer?.subdivisions) {
				return this.offer?.offers || [];
			}

			const pairs = this.offer.offers.map((sub, index) => ({
				...sub,
				unitLabel: this.offer.subdivisions[index]?.label || "General",
			}));

			return pairs.sort((a, b) => a.id - b.id); // ascendent după id
		},

		computedSubdivisions() {
			if (this.offer?.subdivisions?.length) {
				return this.offer.subdivisions;
			}

			if (this.location?.subdivisions?.length) {
				return this.location.subdivisions;
			}

			return [];
		},

		compartmentationOptionsFiltered() {
			return this.showApartments
				? this.compartmentationOptions
				: this.compartmentationOptions.filter(o => o.value !== 2);
		},
		compartmentationValue: {
			get() {
				return Number(this.location?.compartmentation ?? 0);
			},
			set(val) {
				this.updateCompartmentation(val);
			},
		},

		normalizedOfferedProducts() {
			const p = this.offeredProducts;
			return Array.isArray(p) ? p : Object.values(p || {}).flat();
		},

		isWholeLocation() {
			return this.location.compartmentation === 0;
		},

		/**
		 * Groups offered products by unitId.
		 * @returns {Object} Products grouped by unitId, or "no-unit" if missing.
		 */
		productsByUnit() {
			// If offeredProducts is an array, group items by their unitId
			if (Array.isArray(this.offeredProducts)) {
				return (this.offeredProducts || []).reduce((acc, prod) => {
					const key = prod.unitId ?? "no-unit";
					if (!acc[key]) acc[key] = [];
					acc[key].push(prod);

					return acc;
				}, {});
			}
			// If it's already an object, return it as-is
			return this.offeredProducts || {};
		},

		/**
		 * Computes insulation-related data for each room in the current location.
		 *
		 * @returns {Array<Object>} A list of insulation data objects, one per room.
		 * @returns {string|number} return[].floor - The floor identifier (or number) where the room is located.
		 * @returns {?string} return[].insulationType - The type of insulation applied in the room, or `null` if not defined.
		 * @returns {?string} return[].additionalInsulation - Additional insulation applied in the room, or `null` if not defined.
		 *
		 * @description
		 * - Iterates over all rooms in `this.location.rooms`.
		 * - Normalizes missing values to `null` for consistent data handling.
		 * - Returns an empty array if no location or rooms exist.
		 */
		computedInsulationData() {
			if (!this.location || !this.location.rooms) return [];
			return this.location.rooms.map(r => ({
				floor: r.floor,
				insulationType: r.insulationType ?? null,
				additionalInsulations: r.additionalInsulations ?? null,
			}));
		},
	},
	methods: {
		resetPdfSelection() {
			this.showSubofferMenu = false;
			this.selectTotal = false;
			this.selectedSuboffers = [];
		},
		toggleTotal() {
			this.selectTotal = !this.selectTotal;
			if (this.selectTotal) this.selectedSuboffers = [];
		},
		toggleSingleSuboffer(id) {
			this.selectTotal = false;
			this.selectedSuboffers =
				this.selectedSuboffers[0] === id ? [] : [id];
		},
		/**
		 * Normalize a quantity to satisfy backend numeric constraints.
		 *
		 * - Limits total digits (integer + decimals) to `maxDigits`.
		 * - Rounds to `maxDecimals` decimal places.
		 * - Returns a Number safe for API payloads.
		 *
		 * Examples:
		 *  normalizeQuantity(12345678901, 10, 2) -> 1234567890  (trim digits)
		 *  normalizeQuantity(12.34567, 10, 2)    -> 12.35       (round)
		 *  normalizeQuantity("5.0000", 10, 2)    -> 5
		 *
		 * @param {number|string|null|undefined} value - Raw quantity.
		 * @param {number} [maxDigits=10] - Maximum total digits allowed (integer + decimals).
		 * @param {number} [maxDecimals=2] - Maximum decimal places allowed.
		 * @returns {number} Normalized quantity (finite number).
		 */
		normalizeQuantity(q, maxDigits = 10, decimals = 2) {
			let n = Number(q);
			if (!Number.isFinite(n)) return 0;

			n = Number(n.toFixed(decimals));

			const intDigits = Math.trunc(Math.abs(n)).toString().length;
			if (intDigits >= maxDigits) {
				const sign = n < 0 ? -1 : 1;
				const trimmedInt = Math.trunc(Math.abs(n))
					.toString()
					.slice(0, maxDigits);
				return sign * Number(trimmedInt);
			}

			const allowedDecimals = Math.max(0, maxDigits - intDigits);
			const finalDecimals = Math.min(decimals, allowedDecimals);
			return Number(n.toFixed(finalDecimals));
		},

		generatePDFClicked() {
			const doTotal = this.selectTotal;
			const subs = [...this.selectedSuboffers];

			this.showSubofferMenu = false;

			this.$nextTick(() => {
				setTimeout(() => {
					const sorted = this.pdfSuboffers;
					const compositeId = this.offer?.id;
					const numericCompositeId = compositeId
						? Number(compositeId.replace("CO", ""))
						: null;

					// 1) total
					if (doTotal && numericCompositeId) {
						createPDFCompositeTotalOffer(
							numericCompositeId,
							this.pdfType,
							0
						);
					}

					// 2) suboffers
					for (const id of subs) {
						const sub = sorted.find(o => o.id === id);
						if (!sub) continue;

						const unitLabel = this.getUnitLabel(sub);
						const total = sorted.length;
						const index = sorted.findIndex(o => o.id === id) + 1;

						createPDFCompositeOffer(
							id,
							this.pdfType,
							0,
							unitLabel,
							compositeId,
							index,
							total
						);
					}

					// reset UI
					this.selectedSuboffers = [];
					this.selectTotal = false;
				}, 30);
			});
		},
		toggleSelectAllSuboffers() {
			if (this.selectedSuboffers.length === this.pdfSuboffers.length) {
				// deselect all
				this.selectedSuboffers = [];
			} else {
				// select all
				this.selectedSuboffers = this.pdfSuboffers.map(s => s.id);
			}
		},
		generateCompositeTotalPDF() {
			this.showSubofferMenu = false;
			this.$nextTick(() => {
				setTimeout(() => {
					const compositeId = this.offer?.id;
					if (!compositeId) return;
					const numericCompositeId = Number(
						this.offer.id.replace("CO", "")
					);
					createPDFCompositeTotalOffer(
						numericCompositeId,
						this.pdfType,
						0
					);
					this.selectedSuboffers = [];
					this.selectTotal = false;
				}, 30);
			});
		},
		normalizeApartmentLabel(raw) {
			if (!raw) return "Apartament";

			if (typeof raw === "string" && raw.startsWith("unit_")) {
				raw = raw.slice(5);
			}

			if (typeof raw === "string") {
				raw = raw.replace(/_/g, " ");
			}

			if (!isNaN(Number(raw))) {
				const id = Number(raw);
				return APARTMENT_MAP[id] || `Apartament ${id}`;
			}

			return String(raw);
		},
		toggleSuboffer(id) {
			const idx = this.selectedSuboffers.indexOf(id);
			if (idx === -1) this.selectedSuboffers.push(id);
			else this.selectedSuboffers.splice(idx, 1);
		},

		generateSelectedPDFs() {
			this.showSubofferMenu = false;
			this.$nextTick(() => {
				setTimeout(() => {
					const sorted = this.pdfSuboffers;
					for (let i = 0; i < this.selectedSuboffers.length; i++) {
						const id = this.selectedSuboffers[i];
						const sub = sorted.find(o => o.id === id);

						const unitLabel = this.getUnitLabel(sub);
						const compositeId = this.offer.id;
						const total = sorted.length;

						const index = sorted.findIndex(o => o.id === id) + 1;

						createPDFCompositeOffer(
							id, // offerId (suboferta)
							this.pdfType, // type
							0, // sorting
							unitLabel,
							compositeId,
							index,
							total
						);
					}

					this.selectedSuboffers = [];
					this.selectTotal = false;
				}, 30);
			});
		},
		getUnitLabel(suboffer) {
			if (!this.offer?.offers || !this.offer?.subdivisions)
				return "General";
			const sorted = this.pdfSuboffers;

			const index = sorted.findIndex(o => o.id === suboffer.id);
			return this.offer.subdivisions[index]?.label || "General";
		},

		openOfferPDFMenu(type) {
			if (!this.offer?.offers?.length) {
				return createPDFOffer(this.offerId, type, 0);
			}

			this.pdfType = type;
			this.showSubofferMenu = true;
		},

		/**
		 * Marks the current location as changed and prepares it for saving a new version.
		 * Also triggers a recalculation warning if products were previously calculated.
		 *
		 * @returns {void}
		 */
		markLocationChanged() {
			// Clear recommended/special so we don't show previous automation recommendations until recalc
			this.recommendedProducts = [];
			this.specialProducts = [];
			this.recommendedProductsByUnit = {};
			this.specialProductsByUnit = {};
			this.markRecalcOnly();

			if (!this.location || this.location.version <= 0) return;
			this.location.isLocationChanged = true;
			this.location.isNewVersion = true;
			if (this.$refs.roomsDetails) {
				this.$refs.roomsDetails.isDescriptionNeeded = true;
			}
		},

		getUnitTitle(unitId) {
			let title = `${this.formatUnitLabel(unitId)}`;
			if (this.location.compartmentation === 2) {
				title += ` — ${this.getFloorLabelForApartment(unitId)}`;
			}
			return title;
		},

		/**
		 * Flags the current offer as needing recalculation if it was already calculated once.
		 * Displays a warning alert prompting the user to recalculate products.
		 *
		 * @returns {void}
		 */
		markRecalcOnly() {
			this.triedCalc = false;

			if (this.hasCalculatedProducts && !this.needRecalc) {
				this.needRecalc = true;
				showAlertModal(
					this.$store,
					"Datele s-au modificat. Recalculați produsele!",
					"warning",
					3000
				);
			}
		},
		/**
		 * Retrieves the most frequent floor label associated with a given apartment.
		 *
		 * @param {string|number} unitId - The apartment identifier to find the corresponding floor for.
		 * @returns {string} The human-readable floor label (e.g., "Etaj 1" or "Parter").
		 */
		getFloorLabelForApartment(unitId) {
			const rooms = this.location?.rooms || [];
			if (!rooms.length) {
				console.warn("[getFloorLabelForApartment] no rooms found");
				return "";
			}

			const inApt = rooms.filter(
				r =>
					String(getUnitId(r.apartament ?? r.apartment)) ===
					String(unitId)
			);

			// if (!inApt.length) {
			//     console.warn(
			//         "[getFloorLabelForApartment] no match for",
			//         String(unitId)
			//     );
			//     return "";
			// }

			const floors = inApt
				.map(r => Number(r.floor))
				.filter(n => Number.isFinite(n));
			if (!floors.length) return "";

			const counts = floors.reduce(
				(a, f) => ((a[f] = (a[f] || 0) + 1), a),
				{}
			);
			const floorNum = Number(
				Object.keys(counts).sort((a, b) => counts[b] - counts[a])[0]
			);

			const label = FLOOR_MAP?.[floorNum] || ` ${floorNum}`;

			return label;
		},

		/**
		 * Merges calculated IPA products with base price list items.
		 * Assigns subcategory ("Main" or "Supplementary") based on insulation size.
		 *
		 * @param {Array<Object>} priceList - The full list of price list items.
		 * @param {Array<Object>} calcProducts - The list of products calculated from requirements.
		 * @returns {Array<Object>} A merged and sorted array of products with category assignments.
		 */
		matchProductsIpa(priceList, calcProducts) {
			const TACKER_SUBTYPE = 2;
			const ADDITIONAL_TACKER_SUBTYPE = 4;

			const getSubtype = obj => {
				if (!obj) return null;
				if (typeof obj === "number") return obj;
				return (
					obj?.subtype ??
					obj?.specifications?.subtype ??
					obj?.value?.subtype ??
					obj?.insulationType?.value?.subtype ??
					obj?.insulation_type?.value?.subtype ??
					null
				);
			};

			const mergedProducts = calcProducts.map(calc => {
				const calcSubtype = getSubtype(calc);

				// Handle cases where same code exists for different subtypes (e.g. Tacker vs Additional Tacker)
				let base = priceList.find(
					p =>
						p.product_code === calc.product_code &&
						(calcSubtype ? getSubtype(p) === calcSubtype : true)
				);

				// Fallback to code only if strict match fails
				if (!base) {
					base = priceList.find(
						p => p.product_code === calc.product_code
					);
				}

				if (!base) return calc;

				const merged = { ...base, ...calc };
				const finalSubtype = getSubtype(merged);
				const productType =
					merged?.specifications?.type ?? merged?.type ?? null;

				// Simple categorization based on subtype
				if (productType === IPA_PRODUCT_TYPES.INSULATION) {
					if (finalSubtype === ADDITIONAL_TACKER_SUBTYPE) {
						merged.assigned_sub_category = "Produse Suplimentare";
					} else if (finalSubtype === TACKER_SUBTYPE) {
						merged.assigned_sub_category = "Produse Principale";
					}
				}

				// merged.show = merged.quantity === 0;
				return merged;
			});

			const isScoped =
				typeof this.isUnitScoped === "function"
					? this.isUnitScoped()
					: false;

			const deduped = [];
			for (const p of mergedProducts) {
				const key =
					`${p.product_code}|${p.specifications.subtype ?? ""}|${
						p.specifications.size ?? ""
					}` + (isScoped ? `|${p.unitId ?? "no-unit"}` : "");

				const existing = deduped.find(x => x.__key === key);

				if (existing) {
					existing.quantity =
						(Number(existing.quantity) || 0) +
						(Number(p.quantity) || 0);
				} else {
					deduped.push({
						...p,
						quantity: Number(p.quantity) || 0,
						__key: key,
					});
				}
			}

			const cleaned = deduped.map(({ ...rest }) => rest);

			return cleaned.sort((a, b) =>
				(a.product_code || "").localeCompare(
					b.product_code || "",
					"en",
					{ numeric: true }
				)
			);
		},

		/**
		 * Replaces all existing offered products for a given unit with a new list.
		 * Maintains metadata for each product such as unitId, floor, and apartment.
		 *
		 * @param {number|string} unitId - The unit identifier to restore products for.
		 * @param {Array<Object>} products - The list of products to restore.
		 * @returns {void}
		 */
		restoreProductsByUnit(unitId, products) {
			// Normalize offeredProducts to array
			const offered = Array.isArray(this.offeredProducts)
				? this.offeredProducts
				: Object.values(this.offeredProducts || {}).flat();

			// Remove existing products for this unit
			const other = offered.filter(p => p.unitId !== unitId);

			// Add new products with ensured metadata
			const enriched = (products || []).map(p => ({
				...p,
				unitId,
				apartment: p.apartment || null,
				floor: p.floor ?? null,
			}));

			// Rebuild offeredProducts list
			this.offeredProducts = [...other, ...enriched];
			this.offerProducts = [...this.offeredProducts]; // mirror for backend
			this.isProductsChanged = true;
		},

		/**
		 * Updates only the products for a specific unit and replaces them in the overall offer.
		 * Ensures all new products include metadata such as unitId and floor.
		 */
		updateUnitProducts(newProducts, unitId) {
			// Normalize offeredProducts to array
			const offered = Array.isArray(this.offeredProducts)
				? this.offeredProducts
				: Object.values(this.offeredProducts || {}).flat();

			// Keep all products except those from this unit
			const otherUnitsProducts = offered.filter(p => p.unitId !== unitId);

			// Enrich new products with metadata
			const enrichedProducts = (newProducts || []).map(p => ({
				...p,
				unitId,
				apartment: p.apartment || null,
				floor: p.floor ?? null,
			}));

			// Replace old unit products with new ones
			this.offeredProducts = [...otherUnitsProducts, ...enrichedProducts];
			this.offerProducts = [...this.offeredProducts];
			this.isProductsChanged = true;
		},

		/**
		 * Formats a human-readable label for a unit (floor/apartment).
		 */
		formatUnitLabel(unitId) {
			const ct = this.location?.compartmentation ?? 0;

			// Remove "unit_" prefix if exists
			const raw = String(unitId).startsWith("unit_")
				? String(unitId).slice(5)
				: String(unitId);

			if (ct === 1) {
				const floorNum = Number(raw);
				return FLOOR_MAP[floorNum] || `Etaj ${raw}`;
			} else if (ct === 2) {
				const apt = isNaN(Number(raw))
					? raw // manual text
					: APARTMENT_MAP[Number(raw)] || `Apartament ${raw}`;
				return apt;
			}

			return "Întreaga locație";
		},

		/**
		 * Builds a structured list of subdivisions (floors/apartments) with configuration data.
		 * Used when persisting structured location information to the backend.
		 *
		 * @returns {Array<Object>} An array of subdivision objects containing room IDs and configuration fields.
		 */
		buildSubdivisionsPayload() {
			const ct = Number(this.location?.compartmentation ?? 0);
			const cust = Number(this.location?.customization ?? 0);
			const compType = ct === 0 ? cust : ct; // <-- asta e schimbarea cheie
			const subdivisions = [];

			if (compType === 0) {
				const rooms = this.location.rooms || [];
				const cfg = rooms[0] || {};

				subdivisions.push({
					type: 0,
					label: "Întreaga locație",
					rooms: rooms.map(r => r.id).filter(Boolean),
					pipe_diameter: cfg.pipe_diameter ?? null,
					distributor: cfg.distributor ?? null,
					metal_box: cfg.metal_box ?? null,
					temperature_regulation: cfg.temperature_regulation ?? null,
					automation: cfg.automation ?? null,
					automationSelection:
						cfg.automationSelection ??
						cfg.automation_selection ??
						[],
					reinforcement_mesh: cfg.reinforcement_mesh ?? null,
				});
			} else if (compType === 1) {
				const floorIds = this.getUnitIds();
				floorIds.forEach(floorId => {
					const rooms = this.getRoomsByUnit(floorId);
					const cfg = rooms[0] || {};

					subdivisions.push({
						type: 1,
						label: FLOOR_MAP[floorId] || `Etaj ${floorId}`,
						rooms: rooms.map(r => r.id).filter(Boolean),
						pipe_diameter: cfg.pipe_diameter ?? null,
						distributor: cfg.distributor ?? null,
						metal_box: cfg.metal_box ?? null,
						temperature_regulation:
							cfg.temperature_regulation ?? null,
						automation: cfg.automation ?? null,
						automationSelection:
							cfg.automationSelection ??
							cfg.automation_selection ??
							[],
						reinforcement_mesh: cfg.reinforcement_mesh ?? null,
						products: this.productsByUnit[floorId] ?? [],
					});
				});
			} else if (compType === 2) {
				const aptIds = this.getUnitIds();
				aptIds.forEach(aptId => {
					const rooms = this.getRoomsByUnit(aptId);
					const cfg = rooms[0] || {};

					subdivisions.push({
						type: 2,
						label: this.normalizeApartmentLabel(aptId),
						rooms: rooms.map(r => r.id).filter(Boolean),
						pipe_diameter: cfg.pipe_diameter ?? null,
						distributor: cfg.distributor ?? null,
						metal_box: cfg.metal_box ?? null,
						temperature_regulation:
							cfg.temperature_regulation ?? null,
						automation: cfg.automation ?? null,
						automationSelection:
							cfg.automationSelection ??
							cfg.automation_selection ??
							[],
						reinforcement_mesh: cfg.reinforcement_mesh ?? null,
						products: this.productsByUnit[aptId] ?? [],
					});
				});
			}

			return subdivisions;
		},
		/**
		 * Updates the current customization type (0: entire, 1: floors, 2: apartments).
		 * Triggers recalculation notice and marks the location as changed.
		 *
		 * @param {number|string} next - The new customization value to apply.
		 * @returns {void}
		 */
		updateCustomization(next) {
			const val = Number(next);
			if (![0, 1, 2].includes(val)) return;

			const changed = this.location?.customization !== val;
			if (!this.location) this.location = {};
			this.location = { ...this.location, customization: val };
			if (changed) {
				this.recommendedProducts = [];
				this.specialProducts = [];
				this.recommendedProductsByUnit = {};
				this.specialProductsByUnit = {};
				if (this.hasCalculatedProducts) this.needRecalc = true;
				this.markLocationChanged();

				showAlertModal(
					this.$store,
					"Personalizarea s-a schimbat. Cardurile s-au actualizat.Recalculați produsele!",
					"info",
					2000
				);
			}
		},

		/**
		 * Updates the current compartmentation type (0: entire location, 1: floors, 2: apartments).
		 * Resets related data when the compartmentation changes.
		 *
		 * @param {number|string} next - The new compartmentation value.
		 */
		updateCompartmentation(next) {
			const val = Number(next);
			if (![0, 1, 2].includes(val)) return;

			const changed = this.location?.compartmentation !== val;

			// ensure location exists
			if (!this.location) this.location = {};
			this.location = { ...this.location, compartmentation: val };

			// ensure bucket for this comp type
			if (!this.productDetailsData[val]) {
				this.productDetailsData[val] = {
					...(this.productDetailsData[val] || {}),
				};
			}

			if (changed) {
				this.offeredProducts = [];
				this.offerProducts = [];
				this.recommendedProducts = [];
				this.specialProducts = [];
				this.recommendedProductsByUnit = {};
				this.specialProductsByUnit = {};
				this.isProductsChanged = false;
				if (this.hasCalculatedProducts) this.needRecalc = true;
				this.markLocationChanged();

				showAlertModal(
					this.$store,
					"Compartmentarea s-a schimbat. Recalculați produsele!",
					"warning",
					2500
				);

				this.$nextTick(() => {
					this.openPanels = this.getUnitIds().map((_, i) => i);
				});
			}
		},

		/**
		 * Picks a random insulation item from available types.
		 * @returns {Object|null} The selected insulation item or null if none exist.
		 */
		pickRandomInsulationItem() {
			return this.randomFrom(this.insulationTypes || []) || null;
		},

		/**
		 * Returns a random element from an array.
		 * @param {Array} arr - The array to pick from.
		 * @returns {*} A random element, or null if empty or invalid.
		 */
		randomFrom(arr) {
			return Array.isArray(arr) && arr.length
				? arr[Math.floor(Math.random() * arr.length)]
				: null;
		},

		/**
		 * Returns a random subset (0–max items) from an array.
		 * @param {Array} arr - Source array.
		 * @param {number} [max=2] - Maximum number of items to include.
		 * @returns {Array} Randomly selected subset.
		 */
		randomSubset(arr, max = 2) {
			const copy = [...(arr || [])];
			const n = Math.min(
				Math.floor(Math.random() * (max + 1)),
				copy.length
			);
			for (let i = copy.length - 1; i > 0; i--) {
				const j = Math.floor(Math.random() * (i + 1));
				[copy[i], copy[j]] = [copy[j], copy[i]];
			}
			return copy.slice(0, n);
		},
		/**
		 * Finds an insulation item by subtype and size.
		 * @param {string} subtype - The insulation variant (e.g., GROOVED or TACKER).
		 * @param {number|string} size - The insulation size.
		 * @returns {Object|null} Matching insulation object, or null if not found.
		 */
		findInsulationItemBy(subtype, size) {
			const it = (this.insulationTypes || []).find(
				o => o?.value?.subtype === subtype && o?.value?.size === size
			);
			return it ? it.value : null;
		},
		/**
		 * Randomizes unit configuration and insulation setup for all rooms.
		 * - Builds random per-unit or global configuration based on compartmentation.
		 * - Randomly assigns insulation, foil, and additional layers to each room.
		 * - Updates `location.rooms` and marks the location as changed.
		 *
		 * @async
		 * @returns {Promise<void>}
		 */
		async randomizeUnitAndInsulation() {
			if (!this.location?.rooms?.length) {
				showAlertModal(
					this.$store,
					"Nu există camere pentru a randomiza.",
					"warning",
					2500
				);
				return;
			}

			const ct = this.location?.compartmentation ?? 0;

			// ensure compartmentation bucket exists
			this.productDetailsData = {
				...this.productDetailsData,
				[ct]: { ...(this.productDetailsData?.[ct] || {}) },
			};

			// build raw choice pools (values only)
			const pipeVals = (PIPE_CHOICES || []).map(c => c.value);
			const distVals = (DISTRIBUTION_CHOICES || []).map(c => c.value);
			const boxVals = (BOX_FOR_DISTRIBUTION_CHOICES || []).map(
				c => c.value
			);
			const tcVals = (TEMPERATURE_CONTROL_CHOICES || []).map(
				c => c.value
			);
			const autoVals = (AUTOMATION_CHOICES || []).map(c => c.value);
			const meshVals = (NO_YES_CHOICES || []).map(c => c.value);

			// insulation choice pools
			const groovedSizes = Object.values(GROOVED_PANEL_SIZE);
			const tackerSizes = [
				TACKER_PANEL_SIZE.THK_20,
				TACKER_PANEL_SIZE.THK_25,
				TACKER_PANEL_SIZE.THK_30,
				TACKER_PANEL_SIZE.THK_50,
			];
			const foilOptions = (this.tackerFoilTypes || []).map(o => o.value); // numbers
			const addInsValues = (this.additionalInsulationTypes || []).map(
				o => o.value
			); // objects

			// 1) assign per-unit configs if needed
			const perUnitConfig = {}; // { [unitId]: {dist,temp,auto,pipe,box,mesh} }
			if (ct === 1 || ct === 2) {
				const unitIds = this.getUnitIds();
				unitIds.forEach(uid => {
					const distributionType = this.randomFrom(distVals) || 3;
					const tempControlKit = Number(this.randomFrom(tcVals) || 1);
					const automation = Number(this.randomFrom(autoVals) || 1);
					const pipe_diameter = this.randomFrom(pipeVals) || 17;
					const box_for_distribution =
						this.randomFrom(boxVals) || null;
					const reinforcement_mesh = this.randomFrom(meshVals) || 1;

					// store in the compartmentation object (like the form would)
					this.productDetailsData[ct] = {
						...this.productDetailsData[ct],
						[uid]: {
							unit: uid,
							distributor: distributionType,
							temperatureRegulation: tempControlKit,
							automation,
							pipeDiameter: pipe_diameter,
							metalBox: box_for_distribution,
							reinforcementMesh: reinforcement_mesh,
						},
					};

					perUnitConfig[uid] = {
						distributionType,
						tempControlKit,
						automation,
						pipe_diameter,
						box_for_distribution,
						reinforcement_mesh,
					};
				});
			} else {
				// 0) global (building-level) config
				this.productDetailsData = {
					...this.productDetailsData,
					0: {
						pipeDiameter: this.randomFrom(pipeVals) || 17,
						distributor: this.randomFrom(distVals) || 2,
						metalBox: this.randomFrom(boxVals) || null,
						temperatureRegulation: Number(
							this.randomFrom(tcVals) || 1
						),
						automation: Number(this.randomFrom(autoVals) || 1),
						automationSelection: [],
						reinforcementMesh: this.randomFrom(meshVals) || 1,
					},
				};
			}

			// 2) produce updated rooms: insulation (+ per-unit or global product fields)
			const updatedRooms = this.location.rooms.map(room => {
				const r = { ...room };

				// ---- insulation (room-level) ----
				const pickGrooved = Math.random() < 0.5;
				if (pickGrooved) {
					const size = this.randomFrom(groovedSizes);
					r.insulationType = this.findInsulationItemBy(
						INSULATION_VARIANTS.GROOVED,
						size
					);
					r.tackerFoil = 0; // TACKER_FOIL.NONE (keep this numeric!)
					r.tackerRoll = false;
				} else {
					const size = this.randomFrom(tackerSizes);
					r.insulationType = this.findInsulationItemBy(
						INSULATION_VARIANTS.TACKER,
						size
					);
					r.tackerFoil =
						Math.random() < 0.6
							? (this.randomFrom(foilOptions) ?? 0)
							: 0; // number
					r.tackerRoll = Math.random() < 0.5;
				}
				r.additionalInsulations = this.randomSubset(addInsValues, 2);

				// ---- product details (depend on ct) ----
				if (ct === 1 || ct === 2) {
					const uid =
						ct === 1
							? this.toUnitId(r.floor)
							: this.toUnitId(r.apartament ?? r.apartment);
					const cfg = perUnitConfig[uid] || {};
					r.pipe_diameter = cfg.pipe_diameter ?? null;
					r.distributor = cfg.distributionType ?? null;
					r.metal_box = cfg.box_for_distribution ?? null;
					r.temperature_regulation = cfg.tempControlKit ?? null;
					r.automation = cfg.automation ?? null;
					r.reinforcement_mesh = cfg.reinforcement_mesh ?? null;
				} else {
					// global
					const g = this.productDetailsData?.[0] || {};
					r.pipe_diameter = g.pipeDiameter ?? null;
					r.distributor = g.distributor ?? null;
					r.metal_box = g.metalBox ?? null;
					r.temperature_regulation = g.temperatureRegulation ?? null;
					r.automation = g.automation ?? null;
					r.reinforcement_mesh = g.reinforcementMesh ?? 1;
				}

				return this._withDerivedFields(r);
			});

			this.location = {
				...this.location,
				rooms: updatedRooms,
				isLocationChanged: true,
			};
			showAlertModal(
				this.$store,
				"Random complet: setări după compartimentare + izolații pe camere.",
				"success",
				1800
			);
		},

		/**
		 * Converts a given value to a numeric unit ID.
		 * @param {*} v - The value to convert (string or number).
		 * @returns {number|null} The numeric unit ID, or null if invalid.
		 */
		toUnitId(v) {
			const n = Number(v);
			return Number.isFinite(n) ? n : null;
		},
		/**
		 * Collects all unique unit IDs (floors or apartments) based on compartmentation type.
		 * @returns {number[]} Sorted array of unique unit IDs.
		 */
		getUnitIds() {
			const ct = this.location?.compartmentation ?? 0;
			const cust = this.location?.customization ?? 0;

			const effectiveType = ct === 0 ? cust : ct; // 0->ia personalizarea; altfel compartimentarea
			const ids = new Set();

			for (const r of this.location?.rooms || []) {
				if (effectiveType === 1) {
					ids.add(Number(r.floor));
				}
				if (effectiveType === 2) {
					const uid = getUnitId(r.apartament ?? r.apartment ?? "0");
					if (uid) ids.add(uid);
				}
			}

			return [...ids].sort((a, b) => a - b);
		},
		getUnitIdsBySeparation(rooms, separation) {
			const comp = this.location?.compartmentation ?? 0;
			const personalization = this.location?.customization ?? 0;
			const ids = new Set();

			if (separation === "personalization") {
				if (personalization === 0) {
					ids.add(0);
					return [...ids];
				}
				for (const r of rooms || []) {
					if (personalization === 1) {
						ids.add(Number(r.floor));
					}
					if (personalization === 2) {
						const uid = getUnitId(
							r.apartament ?? r.apartment ?? "0"
						);
						if (uid) ids.add(uid);
					}
				}
			} else if (separation === "compartmentation") {
				if (comp === 0) {
					ids.add(0);
					return [...ids];
				}
				for (const r of rooms || []) {
					if (comp === 1) {
						ids.add(Number(r.floor));
					}
					if (comp === 2) {
						const uid = getUnitId(
							r.apartament ?? r.apartment ?? "0"
						);
						if (uid) ids.add(uid);
					}
				}
			}
			return [...ids].sort((a, b) => a - b);
		},
		/**
		 * Returns all rooms belonging to a specific unit (floor or apartment),
		 * depending on the current compartmentation type.
		 * @param {number|string} unitId - The unit identifier to filter by.
		 * @returns {Object[]} Array of matching room objects.
		 */
		getRoomsByUnit(unitId) {
			const ct = this.location?.compartmentation ?? 0;
			const cust = this.location?.customization ?? 0;
			const uid = this.toUnitId(unitId);

			return (this.location?.rooms || []).filter(r => {
				const roomFloorId = this.toUnitId(r.floor);
				const roomAptId = getUnitId(r.apartament ?? r.apartment);
				if (ct === 0) {
					if (cust === 1) {
						// personalizare pe etaje
						return roomFloorId === uid;
					}
					if (cust === 2) {
						// personalizare pe apartamente
						return roomAptId === unitId;
					}
					// dacă e ct=0 și cust=0 → tot building-ul
					return true;
				}
				if (ct === 0) return true;
				if (ct === 1) return this.toUnitId(r.floor) === uid;
				if (ct === 2)
					return getUnitId(r.apartament ?? r.apartment) === unitId;
				return false;
			});
		},
		getRoomsByUnitCustom(unitId, separationType) {
			const personalization = this.location?.customization ?? 0;
			const compartmentation = this.location?.compartmentation ?? 0;
			const uid = this.toUnitId(unitId);

			return (this.location?.rooms || []).filter(r => {
				const roomFloorId = this.toUnitId(r.floor);
				const roomAptId = getUnitId(r.apartament ?? r.apartment);
				if (separationType === "personalization") {
					if (personalization === 0) {
						return true;
					}
					if (personalization === 1) {
						// personalizare pe etaje
						return roomFloorId === uid;
					}
					if (personalization === 2) {
						// personalizare pe apartamente
						return roomAptId === unitId;
					}
				} else if (separationType === "compartmentation") {
					if (compartmentation === 0) {
						return true;
					}
					if (compartmentation === 1) {
						// compartimentare pe etaje
						return roomFloorId === uid;
					}
					if (compartmentation === 2) {
						// compartimentare pe apartamente
						return roomAptId === unitId;
					}
				} else {
					return false;
				}
			});
		},
		/**
		 * Retrieves the configuration for a specific unit (floor/apartment),
		 * including distribution type, automation, and insulation parameters.
		 * Falls back to global defaults or first room values if missing.
		 *
		 * @param {number|string} [unitId=0] - The unit identifier.
		 * @returns {Object} Normalized configuration object:
		 * {
		 *   distributionType: number,
		 *   tempControlKit: number,
		 *   automation: number,
		 *   pipeDiameter: number,
		 *   metalBox: number,
		 *   reinforcementMesh: number
		 * }
		 */
		getUnitConfig(unitId = 0, compType = 0, custType = 1) {
			const root = this.productDetailsData || {};

			const configType = custType === 0 ? 0 : custType;

			let lookupId = unitId;

			if (configType !== 0 && configType !== compType) {
				const roomsInCompUnit = this.getRoomsByUnit(unitId);
				const first = roomsInCompUnit?.[0];

				if (first) {
					if (configType === 1) {
						lookupId = Number(first.floor ?? 0);
					}
					if (configType === 2) {
						lookupId = getUnitId(
							first.apartament ?? first.apartment ?? "0"
						);
					}
				}
			}

			const byType = root[configType] || root[0] || {};
			const keys = Object.keys(byType);

			const normalizedKey = keys.find(
				k =>
					String(k) === String(lookupId) ||
					String(k) === `unit_${lookupId}`
			);

			let raw = {};
			if (configType === 0) {
				raw = byType[0] || byType["0"] || byType || {};
			} else {
				raw = byType[normalizedKey] || {};
			}

			const globalDefaults = root?.[0]?.[0] ||
				root?.[0] || {
					distributor: 3,
					temperatureRegulation: 1,
					automation: 1,
					pipeDiameter: 17,
					metalBox: 2,
					reinforcementMesh: 1,
					insulationType: this.insulationTypes?.[0]?.value ?? null,
					tackerFoil: null,
					additionalInsulations: [],
				};

			if (!raw || Object.keys(raw).length === 0) raw = globalDefaults;

			const normalizeValue = v =>
				v && typeof v === "object" && "value" in v ? v.value : v;

			const normalizeArray = arr =>
				Array.isArray(arr)
					? arr.map(normalizeValue).filter(Boolean)
					: [];

			return {
				distributionType:
					Number(
						raw.distributor ??
							raw.distributionType ??
							globalDefaults.distributor
					) || 1,
				tempControlKit:
					Number(
						raw.temperatureRegulation ??
							raw.tempControlKit ??
							globalDefaults.temperatureRegulation
					) || 1,
				automation:
					Number(raw.automation ?? globalDefaults.automation) || 1,
				automationSelection:
					raw.automationSelection ?? raw.automation_selection ?? [],

				pipeDiameter:
					Number(
						raw.pipeDiameter ??
							raw.pipe_diameter ??
							globalDefaults.pipeDiameter
					) || 17,
				metalBox:
					Number(
						raw.metalBox ?? raw.metal_box ?? globalDefaults.metalBox
					) || 2,
				reinforcementMesh:
					Number(
						raw.reinforcementMesh ??
							raw.reinforcement_mesh ??
							globalDefaults.reinforcementMesh
					) || 1,

				insulationType: normalizeValue(
					raw.insulationType ??
						raw.insulation_type ??
						globalDefaults.insulationType
				),
				tackerFoil: normalizeValue(
					raw.tackerFoil ??
						raw.tacker_foil ??
						globalDefaults.tackerFoil
				),
				additionalInsulations: normalizeArray(
					raw.additionalInsulations ??
						raw.additional_insulations ??
						globalDefaults.additionalInsulations
				),
			};
		},
		/**
		 * Determines whether product/requirements logic should be scoped per unit (floor/apartment)
		 * instead of being aggregated at the whole-location level.
		 *
		 * Scoping is enabled when:
		 * - The location is compartmented by floors (1) or apartments (2), AND
		 * - The UI is not in "show total products" mode.
		 *
		 * @returns {boolean} True if calculations/merging should be unit-scoped, otherwise false.
		 */
		isUnitScoped() {
			const ct = this.location?.compartmentation ?? 0;
			if (this.showTotalProducts) return false;
			return ct === 1 || ct === 2;
		},
		sameSku(a, b) {
			// Compare only by type, subtype, and size (ignore unitId, floor, apartment for merging)
			// This is critical for merging requirements from different units
			return (
				a.type === b.type &&
				a.subtype === b.subtype &&
				a.size === b.size
			);
		},
		/**
		 * Enriches rooms with configuration from productDetailsData.
		 * When personalization !== 0, rooms are enriched per unit (with unitId).
		 * When personalization === 0, all rooms use the same global config (no unitId).
		 *
		 * @param {Array} rooms - Array of room objects to enrich.
		 * @param {Object} cfg - Configuration object from getUnitConfig().
		 * @param {number|string|null} [unitId=null] - Unit identifier to add to rooms (only when personalization !== 0).
		 * @returns {Array} Enriched room objects with all configuration fields.
		 */
		enrichRoomsWithConfig(rooms, cfg, unitId = null, pUnitId = null) {
			// Helper to normalize values (handles both direct values and {value: ...} objects)
			const normalizeValue = v =>
				v && typeof v === "object" && "value" in v ? v.value : v;

			const normalizeArray = arr =>
				Array.isArray(arr)
					? arr.map(normalizeValue).filter(Boolean)
					: [];

			return rooms.map(r => {
				const enriched = {
					...r,
					// Insulation fields
					// Insulation fields
					insulationType:
						normalizeValue(cfg.insulationType) ??
						normalizeValue(r.insulationType) ??
						null,
					tackerFoil:
						normalizeValue(cfg.tackerFoil) ??
						normalizeValue(r.tackerFoil) ??
						0,
					additionalInsulations: normalizeArray(
						cfg.additionalInsulations ??
							r.additionalInsulations ??
							[]
					),
					// Distribution and system configuration
					distributionType:
						cfg.distributionType ??
						cfg.distributor ??
						r.distributionType ??
						null,
					tempControlKit:
						cfg.tempControlKit ??
						cfg.temperatureRegulation ??
						r.tempControlKit ??
						null,
					automation: cfg.automation ?? r.automation ?? null,
					automationSelection:
						cfg.automationSelection ?? r.automationSelection ?? [],
					pipeDiameter: cfg.pipeDiameter ?? r.pipeDiameter ?? null,
					metalBox: cfg.metalBox ?? r.metalBox ?? null,
					reinforcementMesh:
						cfg.reinforcementMesh ?? r.reinforcementMesh ?? null,
				};

				// Add unitId only when provided (personalization !== 0, per-unit mode)
				if (unitId !== null) {
					enriched.unitId = unitId;
				}
				if (pUnitId !== null) {
					enriched.pUnitId = pUnitId;
				}

				return enriched;
			});
		},
		/**
		 * Builds a fully enriched rooms list based on personalization and compartmentation.
		 *
		 * @param {number} personalization
		 * @param {number} compartmentation
		 * @returns {Array}
		 */
		buildEnrichedRooms(personalization, compartmentation) {
			let enrichedRooms = [];
			const pUnitIds = this.getUnitIdsBySeparation(
				this.location?.rooms || [],
				"personalization"
			);

			for (const pUnitId of pUnitIds) {
				const roomsForUnit =
					personalization === 0
						? this.location?.rooms || []
						: this.getRoomsByUnitCustom(pUnitId, "personalization");
				if (!roomsForUnit.length) continue;

				const unitConfig =
					personalization === 0
						? this.getUnitConfig(
								0,
								compartmentation,
								personalization
							)
						: this.getUnitConfig(pUnitId, 0, personalization);

				const enrichedUnitRooms = this.enrichRoomsWithConfig(
					roomsForUnit,
					unitConfig,
					null,
					personalization === 0 ? 0 : pUnitId
				);
				enrichedRooms.push(...enrichedUnitRooms);
			}

			return this.assignUnitIdToRooms(enrichedRooms, compartmentation);
		},
		/**
		 * Assigns compartmentation unitId to rooms for grouping.
		 *
		 * @param {Array} rooms - Rooms without unitId.
		 * @returns {Array} Rooms with unitId assigned.
		 */
		assignUnitIdToRooms(rooms, compartmentation = 0) {
			if (compartmentation === 0) {
				return rooms || [];
			}
			return (rooms || []).map(room => {
				if (compartmentation === 1) {
					return {
						...room,
						unitId: this.toUnitId(room.floor),
					};
				}
				if (compartmentation === 2) {
					return {
						...room,
						unitId: getUnitId(room.apartament ?? room.apartment),
					};
				}
				return room;
			});
		},

		/**
		 * Merges a requirement into a target array by matching SKU.
		 * If a matching SKU already exists (and same unit if scoped), sums the quantities.
		 * Otherwise, adds the requirement as a new entry.
		 *
		 * @param {Object} req - The requirement object to merge.
		 * @param {Array} targetArray - The array to merge into (mutated).
		 * @param {boolean} [respectUnitScope=false] - Whether to match by unitId when scoped.
		 */
		mergeRequirementIntoArray(req, targetArray, respectUnitScope = false) {
			const addQty = Number(req.quantity ?? 1) || 0;

			const match = r => {
				if (respectUnitScope && this.isUnitScoped()) {
					return this.sameSku(r, req) && r.unitId === req.unitId;
				}
				return this.sameSku(r, req);
			};

			const existing = targetArray.find(match);

			if (existing) {
				existing.quantity = (Number(existing.quantity) || 0) + addQty;
				return;
			}

			const copy = {
				...req,
				quantity: addQty,
				unitId: req.unitId ?? null,
				floor: req.floor ?? null,
				apartment: req.apartment ?? null,
			};
			targetArray.push(copy);
		},
		/**
		 * Mirrors VMC behavior: when the child emits an updated location that has
		 * `isLocationChanged: true`, flip savedLocation -> false so createSaveOffer()
		 * routes into handleOfferVMCAction().
		 * @param {Object} location - The updated location.
		 * @returns {void}
		 */
		getLocationChanges(location) {
			if (this.savedLocation) {
				this.savedLocation = !location.isLocationChanged;
			}

			if (!this.location) {
				this.location = { ...location };
				return;
			}

			this.location.compartmentation = Number(
				location?.compartmentation ?? 0
			);
			this.location.customization = Number(location?.customization ?? 0);
			this.location.isLocationChanged = !!location.isLocationChanged;
			this.location.newVersion = !!location.newVersion;
			this.location.change_description =
				location.change_description || "";

			if (Array.isArray(location.rooms)) {
				this.location.rooms.splice(
					0,
					this.location.rooms.length,
					...location.rooms
				);
			}
		},
		/**
		 * Validates and persists the current location, similar to VMC’s verify flow.
		 *
		 * @param {string} change_description - Optional description text for the update.
		 * @returns {Promise<void>} Resolves when the location update succeeds.
		 *
		 * @description
		 * - Updates `location.change_description`.
		 * - Runs `checkForEmptyRooms` to validate rooms.
		 * - Calls `updateLocation()` if validation passes.
		 */
		async verifyLocation(change_description) {
			this.location.change_description = change_description || "";
			if (this.checkForEmptyRooms(this.location)) {
				await this.saveLocation(change_description); // sets savedLocation = true on success
			}
		},
		// ————— IPA-specific requirement builders —————
		deriveIpaSelections,
		createBoxesRequirements,
		calcIpaRequirements,
		/**
		 * Ensures a room object has all derived numeric fields (pipe totals, circuits).
		 *
		 * @param {Object} r - Raw room object.
		 * @param {Object} r.area - Room area object with `sq_m`.
		 * @param {number|string} [r.mounting_step=10] - Mounting step size.
		 * @param {number} [r.total_pipe] - Precalculated total pipe length.
		 * @param {number} [r.circuit_no] - Precalculated circuit count.
		 * @returns {Object} The normalized room with derived fields: `total_pipe`, `circuit_no`, `circuit_length`.
		 */
		_withDerivedFields(r) {
			const area = Number(r?.area?.sq_m ?? 0);
			const step = Number(r?.mounting_step ?? 10);
			const total =
				r.total_pipe != null
					? Number(r.total_pipe)
					: Math.round((100 / step) * area * 100) / 100;
			const circuits =
				r.circuit_no != null
					? Number(r.circuit_no)
					: total > 0
						? Math.ceil(total / 95)
						: 0;
			const length =
				circuits > 0 ? Math.round((total / circuits) * 100) / 100 : 0;

			return {
				...r,
				area: { sq_m: area },
				mounting_step: step,
				total_pipe: total,
				circuit_no: circuits,
				circuit_length: length,
			};
		},

		/**
		 * Updates room → product mapping and offer configuration with provided form data.
		 *
		 * @param {Object} data - Product details from the ProductDetails form.
		 * @param {?string|number} data.pipeDiameter
		 * @param {?string|number} data.distributor
		 * @param {?string|number} data.metalBox
		 * @param {?string|number} data.temperatureRegulation
		 * @param {?string|number} data.automation
		 * @param {?string|number} data.reinforcementMesh
		 * @returns {void}
		 */
		updateOfferDetails(data, unitId = 0) {
			const ct = this.location?.compartmentation ?? 0;

			if (ct === 0) {
				this.productDetailsData = {
					...this.productDetailsData,
					0: { ...data },
				};
			} else {
				this.productDetailsData = {
					...this.productDetailsData,
					[ct]: {
						...(this.productDetailsData?.[ct] || {}),
						[unitId]: { ...data },
					},
				};
			}

			this.location.isLocationChanged = true;
		},
		/**
		 * Main method to process IPA required products and push them to ProductTable.
		 *
		 * @returns {void}
		 *
		 * @description
		 * - Clears previous results and errors.
		 * - Calls `getRequirements()` to build IPA requirements.
		 * - Matches requirements against `ipaProducts`.
		 * - Optionally adds recommended products and post-processes results.
		 * - Matches against price list and updates the ProductTable.
		 */
		processRequiredProducts() {
			this.triedCalc = true;

			this.$refs.roomsDetails?.deleteEmptyRooms?.();

			if (!this.checkForEmptyIpaRooms(this.location)) {
				return;
			}
			if (this.__ipa_processing_active) return;
			this.__ipa_processing_active = true;
			setTimeout(() => (this.__ipa_processing_active = false), 1500);

			// Cancel any pending calculation so only one run applies (avoids double addOrUpdateOfferedProducts)
			if (this._ipaCalcTimeoutId != null) {
				clearTimeout(this._ipaCalcTimeoutId);
				this._ipaCalcTimeoutId = null;
			}

			this._ipaCalcTimeoutId = setTimeout(() => {
				this._ipaCalcTimeoutId = null;
				// 1) reset state — clear previous products so calculation builds from scratch
				this.$store.commit("emptyVmcErrorArray");
				this.requirementsObj = { requirements: [], byUnit: {} }; // keep both shapes
				this.resultedProducts = [];
				this.finalResultedProducts = [];
				this.recommendedProducts = [];
				this.specialProducts = [];
				this.recommendedProductsByUnit = {};
				this.specialProductsByUnit = {};
				// Do not clear offeredProducts/offerProducts here — addOrUpdateOfferedProducts
				// merges new calculation with existing and preserves manual_added items.

				this.getRequirements();

				if (
					this.location?.compartmentation === 0 ||
					this.showTotalProducts
				) {
					// global path

					this.resultedProducts = [];
					this.finalResultedProducts = [];

					this.getProducts(
						{ requirements: this.requirementsObj.requirements },
						JSON.parse(JSON.stringify(this.ipaProducts))
					);

					this.finalResultedProducts = JSON.parse(
						JSON.stringify(this.resultedProducts)
					);

					// Global path: requirements can have unitId 0, so getProducts fills
					// recommendedProductsByUnit[0] instead of recommendedProducts. Flatten
					// so populateSpecialProductsFromRecommended (which uses recommendedProducts when comp === 0) shows them.
					const byUnit = this.recommendedProductsByUnit || {};
					const seen = new Set();
					this.recommendedProducts = (
						this.recommendedProducts || []
					).slice();
					for (const codes of Object.values(byUnit)) {
						for (const c of Array.isArray(codes) ? codes : []) {
							const code =
								typeof c === "string"
									? c
									: (c && c.product_code) || String(c);
							if (code && !seen.has(code)) {
								seen.add(code);
								this.recommendedProducts.push(
									typeof c === "string"
										? c
										: { product_code: code }
								);
							}
						}
					}
				} else {
					// per-unit path: recommended/special per unit (e.g. different automation per floor)
					this.resultedProductsByUnit = {};
					this.finalResultedProducts = []; // reset once
					this.recommendedProductsByUnit = {};

					for (const [unitId, unitReqs] of Object.entries(
						this.requirementsObj.byUnit
					)) {
						this.resultedProducts = [];
						this.getProducts(
							{ requirements: unitReqs },
							JSON.parse(JSON.stringify(this.ipaProducts))
						);

						// save per-unit
						this.resultedProductsByUnit[unitId] = [
							...this.resultedProducts,
						];

						// accumulate into finalResultedProducts (important!)
						this.finalResultedProducts.push(
							...this.resultedProducts
						);
					}
				}

				this.addRecommendedProducts(
					this.finalResultedProducts,
					this.ipaProducts
				);

				// TODO this dubles the quantity,if absolutely needed, resolve that first
				// if (this.processResultedProducts) {
				//     this.processResultedProducts();
				// }

				// 6) price list match

				this.finalResultedProducts = this.matchProductsIpa(
					this.products,
					JSON.parse(JSON.stringify(this.finalResultedProducts))
				);

				this.finalResultedProducts = this.finalResultedProducts.map(
					p => ({
						...p,
						quantity: this.normalizeQuantity(p.quantity, 10, 2),
					})
				);

				// 7) push into table
				this.addOrUpdateOfferedProducts();

				// 8) show recommended products (from automation etc.) in special products section
				this.populateSpecialProductsFromRecommended();

				emitter.emit("trigger-overlay");
				this.$nextTick(() => {
					const tables = this.$refs.productTables || [];
					if (Array.isArray(tables)) {
						tables.forEach(t => {
							if (t && typeof t === "object")
								t.showOnlyOfferQty = true;
						});
					} else if (tables) {
						tables.showOnlyOfferQty = true;
					}
				});

				// emitting event for setting showOnlyOfferQty on true in ProductTable
				this.$nextTick(() => {
					const globalT = this.$refs.productTableGlobal;
					if (globalT) globalT.showOnlyOfferQty = true;

					const tables = this.$refs.productTables || [];
					if (Array.isArray(tables)) {
						tables.forEach(t => t && (t.showOnlyOfferQty = true));
					} else if (tables) {
						tables.showOnlyOfferQty = true;
					}
				});

				this.hasCalculatedProducts = true;
				this.needRecalc = false;
			}, 500);
		},

		/**
		 * Populates specialProducts (or specialProductsByUnit when comp 1/2) from recommended product codes.
		 * When compartmentation is 1 or 2, each unit (e.g. floor) gets its own special list so automation 3 on one floor
		 * and automation 1 on another show different recommended products per table.
		 */
		populateSpecialProductsFromRecommended() {
			const comp = this.location?.compartmentation ?? 0;
			const hasProducts =
				Array.isArray(this.products) && this.products.length > 0;

			if (comp === 1 || comp === 2) {
				this.specialProducts = [];
				this.specialProductsByUnit = {};
				if (!hasProducts) return;
				const byUnit = this.recommendedProductsByUnit || {};
				for (const [unitId, codes] of Object.entries(byUnit)) {
					const list = Array.isArray(codes) ? codes : [];
					if (!list.length) continue;
					const codeSet = new Set(
						list.map(c =>
							typeof c === "string"
								? c
								: (c && c.product_code) || String(c)
						)
					);
					this.specialProductsByUnit[unitId] = this.products
						.filter(p => p && codeSet.has(p.product_code))
						.map(p => ({ ...p }));
				}
				return;
			}

			const codes = Array.isArray(this.recommendedProducts)
				? this.recommendedProducts
				: [];
			this.specialProductsByUnit = {};
			if (!codes.length || !hasProducts) {
				this.specialProducts = [];
				return;
			}
			const codeSet = new Set(
				codes.map(c =>
					typeof c === "string"
						? c
						: (c && c.product_code) || String(c)
				)
			);
			this.specialProducts = this.products
				.filter(p => p && codeSet.has(p.product_code))
				.map(p => ({ ...p }));
		},

		/**
		 * If automation is 2 or 3 and none of the recommended thermostats has quantity > 0, shows a warning.
		 * Call before save/create offer. Does not block the action.
		 */
		showRecommendedThermostatWarningIfNeeded() {
			const comp = this.location?.compartmentation ?? 0;
			const cust = this.location?.customization ?? 0;
			const rooms = this.location?.rooms;

			const automationValue = val => {
				const v = val?.value ?? val;
				return Number(v);
			};

			let hasAutomation2Or3 = false;
			// 1) From rooms (when populated)
			if (Array.isArray(rooms) && rooms.length) {
				hasAutomation2Or3 = rooms.some(
					room =>
						automationValue(room.automation) === 2 ||
						automationValue(room.automation) === 3
				);
			}
			// 2) From getUnitConfig for comp 1 or 2 (per-unit config)
			if (!hasAutomation2Or3 && (comp === 1 || comp === 2)) {
				const unitIds = this.getUnitIds?.() ?? [];
				const effectiveCust = cust || 1;
				for (const unitId of unitIds) {
					const cfg = this.getUnitConfig?.(
						unitId,
						comp,
						effectiveCust
					);
					if (
						cfg &&
						(automationValue(cfg.automation) === 2 ||
							automationValue(cfg.automation) === 3)
					) {
						hasAutomation2Or3 = true;
						break;
					}
				}
			}
			// 3) Direct scan of productDetailsData (form state) – works even if rooms not synced yet
			//    Shape: { [custType]: { [unitId]: { automation, ... } } }, automation can be { value: 2 } or 2
			if (!hasAutomation2Or3 && this.productDetailsData) {
				const root = this.productDetailsData;
				for (const type of [0, 1, 2]) {
					const byType = root[type] ?? root[String(type)];
					if (!byType || typeof byType !== "object") continue;
					for (const key of Object.keys(byType)) {
						const block = byType[key];
						if (
							block &&
							typeof block === "object" &&
							(automationValue(block.automation) === 2 ||
								automationValue(block.automation) === 3)
						) {
							hasAutomation2Or3 = true;
							break;
						}
					}
					if (hasAutomation2Or3) break;
				}
			}
			if (!hasAutomation2Or3) return;

			const thermostatSet = new Set(RECOMMENDED_THERMOSTAT_PRODUCT_CODES);
			// Normalize: offeredProducts can be array or object (by unit) for composite offers
			const raw = this.offeredProducts;
			const offered = Array.isArray(raw)
				? raw
				: raw && typeof raw === "object"
					? Object.values(raw).flat()
					: [];
			const parseQty = q =>
				typeof q === "number"
					? q
					: parseFloat(String(q).replace(",", ".")) || 0;
			// At least one recommended thermostat selected with quantity > 0
			const hasRecommendedThermostatSelected = offered.some(
				p =>
					p &&
					p.product_code &&
					thermostatSet.has(p.product_code) &&
					parseQty(p.quantity) > 0
			);
			// Show warning when automation 2 or 3 but NO recommended thermostat is selected
			if (hasRecommendedThermostatSelected) return;

			showAlertModal(
				this.$store,
				"Atenție: Automatizarea este activă, dar nu a fost selectat niciun termostat.",
				"danger",
				2500
			);
		},

		/**
		 * Builds IPA product requirements using `calcIpaRequirements` and merges them into `requirementsObj`.
		 *
		 * @returns {void}
		 *
		 * @description
		 * - Calls `calcIpaRequirements` with config + rooms.
		 * - Deduplicates by comparing requirements.
		 * - Sums quantities where applicable.
		 */
		buildRequirementsForUnit(unitRooms, unitId, unitKey, unroundedReqs) {
			if (!Array.isArray(unitRooms) || !unitRooms.length) return;
			if (unitId === null || unitId === undefined) return;

			const reqs =
				this.calcIpaRequirements({
					rooms: unitRooms,
					unitScope: true,
				}) || [];
			const unitRoom = unitRooms[0] || {};
			const normalizedReqs = reqs.map(r => ({
				...r,
				[unitKey]: unitId,
				unitId: unitRoom.unitId ?? r.unitId ?? null,
				floor: unitRoom.floor ?? null,
				apartment:
					unitRoom.apartament ??
					unitRoom.apartment ??
					r.apartment ??
					null,
			}));

			// Merge unrounded requirements for this personalization unit
			for (const req of normalizedReqs) {
				this.mergeRequirementIntoArray(req, unroundedReqs);
			}
			return;
		},
		getRequirements() {
			// reset
			this.requirementsObj = { requirements: [], byUnit: {} };

			const compartmentation = this.location?.compartmentation ?? 0;
			const personalization = Number(this.location?.customization ?? 0);

			// Enrich all rooms upfront based on personalization setting
			let enrichedRooms = this.buildEnrichedRooms(
				personalization,
				compartmentation
			);
			const requirementsByUnit = {};
			const combinedRequirements = [];
			const unitGroups = this.splitEnrichedRoomsBySeparation(
				enrichedRooms,
				compartmentation
			);
			for (const unitRooms of unitGroups) {
				const pUnitIds = this.getUnitIdsBySeparation(
					unitRooms,
					"personalization"
				);
				const unitKey = unitRooms?.[0]?.unitId ?? 0;
				const unroundedReqs = [];

				// Collect all unrounded requirements from personalization units
				for (const pUnitId of pUnitIds) {
					// Rooms belonging to the current personalization unit
					const pUnitRooms =
						personalization === 0
							? unitRooms
							: unitRooms.filter(r => r.pUnitId === pUnitId);
					if (!pUnitRooms.length) continue;

					// Calculate raw requirements scoped to this personalization unit
					this.buildRequirementsForUnit(
						pUnitRooms,
						unitKey,
						"unitId",
						unroundedReqs
					);
				}

				// Round once per compartmentation unit after merging all personalization units
				if (unroundedReqs.length) {
					const roundedUnitReqs = roundRequirements(unroundedReqs, {
						rooms: unitRooms || [],
						unitId: unitKey,
						addGroovedClips: true,
					});
					requirementsByUnit[unitKey] = roundedUnitReqs;
					for (const req of roundedUnitReqs) {
						this.mergeRequirementIntoArray(
							req,
							combinedRequirements
						);
					}
				}
			}
			const mergedRequirements = [];
			for (const req of combinedRequirements) {
				this.mergeRequirementIntoArray(req, mergedRequirements, false);
			}
			this.requirementsObj.byUnit = requirementsByUnit;
			this.requirementsObj.requirements = mergedRequirements;
			return;
		},

		splitEnrichedRoomsBySeparation(rooms, compartmentation = 0) {
			// Group rooms by compartmentation type (floor or apartment)
			// Returns an array of arrays, where each inner array contains rooms for one unit
			// Also assigns the compartmentation unitId to each room
			if (compartmentation === 1) {
				// Group by floor and assign floor as unitId
				const floorGroups = {};
				rooms.forEach(room => {
					const floor = room.floor;
					if (floor !== null && floor !== undefined) {
						const floorId = this.toUnitId(floor);
						if (!floorGroups[floorId]) {
							floorGroups[floorId] = [];
						}
						// Assign compartmentation unitId to the room
						const roomWithUnitId = {
							...room,
							unitId: floorId,
						};
						floorGroups[floorId].push(roomWithUnitId);
					}
				});
				return Object.values(floorGroups);
			} else if (compartmentation === 2) {
				// Group by apartment and assign apartment ID as unitId
				const apartmentGroups = {};
				rooms.forEach(room => {
					const apartment = room.apartament ?? room.apartment;
					if (apartment !== null && apartment !== undefined) {
						const aptId = getUnitId(apartment);
						if (aptId) {
							if (!apartmentGroups[aptId]) {
								apartmentGroups[aptId] = [];
							}
							// Assign compartmentation unitId to the room
							const roomWithUnitId = {
								...room,
								unitId: aptId,
							};
							apartmentGroups[aptId].push(roomWithUnitId);
						}
					}
				});
				return Object.values(apartmentGroups);
			} else {
				// No compartmentation: return all rooms as a single group
				// No need to assign unitId when compartmentation === 0
				return [rooms];
			}
		},
		// updateOfferProducts(products) {
		// 	// handle updated product list
		// 	this.offeredProducts = JSON.parse(JSON.stringify(products));
		// 	this.isProductsChanged = true; /*
		// TODO: This is only a temporary fix for OfferIPA.
		// Replace with the common implementation from offerMixin
		// once the calculation logic is ready.
		// */
		// },

		/**
		 * Validates and normalizes IPA rooms, then persists location to backend.
		 *
		 * @param {string} changeDescription - Description for save/versioning.
		 * @returns {Promise<void>}
		 *
		 * @description
		 * - Normalizes room numeric fields (floor, area, steps, etc).
		 * - Runs `checkForEmptyIpaRooms()` validation.
		 * - Calls `updateLocation()` on success.
		 */
		async verifyIpaLocation(changeDescription) {
			this.location.change_description = changeDescription;

			if (this.checkForEmptyIpaRooms(this.location)) {
				await this.saveLocation(changeDescription);
			}
		},

		/**
		 * IPA validation similar to VMC's checkForEmptyRooms:
		 * require a name if area > 0; remove zero-area rooms.
		 * @param {Object} location
		 * @returns {boolean} True if OK, false to abort.
		 */
		checkForEmptyIpaRooms(location) {
			const rooms = Array.isArray(location?.rooms) ? location.rooms : [];
			for (let i = rooms.length - 1; i >= 0; i--) {
				const room = rooms[i];
				const name = (room?.name ?? "").trim();
				const area = Number(room?.area?.sq_m ?? 0);

				if (!name && area > 0) {
					showAlertModal(
						this.$store,
						"Vă rugăm completați denumirea camerei IPA înainte de a salva.",
						"warning",
						2000
					);
					return false;
				}
				if (!area) {
					rooms.splice(i, 1);
				}
			}
			location.rooms = rooms;
			return true;
		},

		/**
		 * Persists location with product defaults injected, marks as saved.
		 *
		 * @param {string} changeDescription - Save/versioning description.
		 * @returns {Promise<void>}
		 */
		resolveUnitConfig(bucket, candidates = [], normalizedUnitId = null) {
			if (!bucket || typeof bucket !== "object") return undefined;

			const filteredCandidates = (candidates || []).filter(
				key =>
					key !== undefined &&
					key !== null &&
					!(typeof key === "string" && key.trim() === "")
			);

			for (const key of filteredCandidates) {
				if (bucket[key] !== undefined) return bucket[key];
			}

			const stringCandidates = filteredCandidates.map(key => String(key));

			if (normalizedUnitId) {
				stringCandidates.push(String(normalizedUnitId));
			}

			const toPrimitive = val => {
				if (val === undefined || val === null) return null;
				if (typeof val === "object") {
					return (
						val.value ??
						val.id ??
						val.raw ??
						val.label ??
						val.name ??
						null
					);
				}
				return val;
			};

			const matched = Object.values(bucket).find(cfg => {
				if (!cfg || typeof cfg !== "object") return false;

				const unitField = cfg.unit ?? cfg.unitId ?? null;
				const rawField = cfg.rawUnit ?? cfg.rawUnitId ?? null;

				if (
					unitField != null &&
					stringCandidates.includes(String(unitField))
				) {
					return true;
				}

				if (
					rawField != null &&
					stringCandidates.includes(String(rawField))
				) {
					return true;
				}

				if (!normalizedUnitId) return false;

				if (
					unitField != null &&
					String(unitField) === String(normalizedUnitId)
				) {
					return true;
				}

				const rawPrimitive = toPrimitive(rawField);
				if (rawPrimitive != null) {
					if (
						typeof rawPrimitive === "string" &&
						rawPrimitive.startsWith("unit_")
					) {
						return (
							String(rawPrimitive) === String(normalizedUnitId)
						);
					}

					const normalizedRaw = getUnitId(rawPrimitive);
					if (
						normalizedRaw &&
						String(normalizedRaw) === String(normalizedUnitId)
					) {
						return true;
					}
				}

				return false;
			});

			if (matched) return matched;

			const configFieldKeys = [
				"pipeDiameter",
				"pipe_diameter",
				"distributor",
				"metalBox",
				"metal_box",
				"temperatureRegulation",
				"temperature_regulation",
				"automation",
				"reinforcementMesh",
				"reinforcement_mesh",
				"insulationType",
				"insulation_type",
				"tackerFoil",
				"tacker_foil",
				"additionalInsulations",
				"additional_insulations",
			];

			const hasConfigFields = configFieldKeys.some(key =>
				Object.prototype.hasOwnProperty.call(bucket, key)
			);

			if (hasConfigFields) return bucket;

			return undefined;
		},

		async saveLocation(changeDescription) {
			if (!this.location?.id) {
				this.location.newVersion = false;
			}
			const rooms = this.location?.rooms ?? [];
			const compType = this.location?.compartmentation ?? 0;
			const custType = this.location?.customization ?? 0;
			const effectiveType = compType === 0 ? custType : compType;

			const bComp = this.productDetailsData?.[compType] || {};
			const bCust = this.productDetailsData?.[custType] || {};
			const b0 = this.productDetailsData?.[0] || {};

			const payload = {
				...this.location,
				show_apartments: this.showApartments,
				change_description:
					changeDescription || this.location.change_description || "",
				rooms: rooms
					.filter(r => r)
					.map(r => {
						const floorId = Number(r.floor);
						const rawApartmentInput =
							r.apartament ?? r.apartment ?? null;

						const apartmentValue =
							rawApartmentInput &&
							typeof rawApartmentInput === "object"
								? (rawApartmentInput.value ??
									rawApartmentInput.id ??
									rawApartmentInput.raw ??
									rawApartmentInput.label ??
									null)
								: rawApartmentInput;

						let normalizedUnitId = null;
						const unitKeyCandidates = new Set();

						if (effectiveType === 1) {
							if (!Number.isNaN(floorId)) {
								unitKeyCandidates.add(floorId);
								unitKeyCandidates.add(String(floorId));
							}
						} else if (effectiveType === 2) {
							if (
								apartmentValue !== null &&
								apartmentValue !== undefined &&
								!(
									typeof apartmentValue === "string" &&
									apartmentValue.trim() === ""
								)
							) {
								unitKeyCandidates.add(apartmentValue);
								unitKeyCandidates.add(String(apartmentValue));

								const numericApartment = Number(apartmentValue);
								if (!Number.isNaN(numericApartment)) {
									unitKeyCandidates.add(numericApartment);
									unitKeyCandidates.add(
										String(numericApartment)
									);
								}
							}

							normalizedUnitId = apartmentValue
								? typeof apartmentValue === "string" &&
									apartmentValue.startsWith("unit_")
									? apartmentValue
									: getUnitId(apartmentValue)
								: null;

							if (normalizedUnitId) {
								unitKeyCandidates.add(normalizedUnitId);
								if (
									typeof normalizedUnitId === "string" &&
									normalizedUnitId.startsWith("unit_")
								) {
									unitKeyCandidates.add(
										normalizedUnitId.slice(5)
									);
								}
							} else {
								unitKeyCandidates.add("unit_0");
							}
						}

						unitKeyCandidates.add(0);
						unitKeyCandidates.add("0");
						unitKeyCandidates.add("unit_0");

						const candidateList = Array.from(
							unitKeyCandidates
						).filter(
							key =>
								key !== undefined &&
								key !== null &&
								!(typeof key === "string" && key.trim() === "")
						);
						const preferCust =
							compType === 0 &&
							(custType === 1 || custType === 2);

						const unitConfig = preferCust
							? this.resolveUnitConfig(
									bCust,
									candidateList,
									normalizedUnitId
								) ||
								this.resolveUnitConfig(
									bComp,
									candidateList,
									normalizedUnitId
								) ||
								this.resolveUnitConfig(
									b0,
									candidateList,
									normalizedUnitId
								) ||
								{}
							: this.resolveUnitConfig(
									bComp,
									candidateList,
									normalizedUnitId
								) ||
								this.resolveUnitConfig(
									bCust,
									candidateList,
									normalizedUnitId
								) ||
								this.resolveUnitConfig(
									b0,
									candidateList,
									normalizedUnitId
								) ||
								{};

						return {
							id: r.id || undefined,
							name: r.name || "",
							floor: Number(r.floor ?? 0),
							apartament:
								typeof apartmentValue === "string" &&
								apartmentValue.startsWith("unit_")
									? apartmentValue.slice(5)
									: (apartmentValue ?? null),
							area: { sq_m: Number(r?.area?.sq_m || 0) },
							height: Number(r?.height ?? 250),
							mounting_step: Number(r?.mounting_step ?? 10),
							total_pipe:
								r?.total_pipe != null
									? Number(r.total_pipe)
									: null,
							circuit_no:
								r?.circuit_no != null
									? Number(r.circuit_no)
									: null,
							circuit_length_ipa:
								r?.circuit_length_ipa != null
									? Number(r.circuit_length_ipa)
									: null,

							is_total_pipe_edited: !!r?.is_total_pipe_edited,
							is_circuit_no_edited: !!r?.is_circuit_no_edited,
							is_circuit_length_edited:
								!!r?.is_circuit_length_edited,
							initial_circuit_length:
								r?.initial_circuit_length ?? 15,
							insulationType:
								unitConfig.insulation_type ??
								unitConfig.insulationType ??
								r?.insulationType ??
								null,

							additionalInsulations: Array.isArray(
								unitConfig.additional_insulations ||
									unitConfig.additionalInsulations
							)
								? (
										unitConfig.additional_insulations ||
										unitConfig.additionalInsulations
									).filter(Boolean)
								: Array.isArray(r?.additionalInsulations)
									? r.additionalInsulations.filter(Boolean)
									: [],

							tackerFoil:
								unitConfig.tacker_foil ??
								unitConfig.tackerFoil ??
								r?.tackerFoil ??
								null,

							pipe_diameter:
								unitConfig.pipe_diameter ??
								r?.pipe_diameter ??
								null,
							distributor:
								unitConfig.distributor ??
								r?.distributor ??
								null,
							metal_box:
								unitConfig.metal_box ?? r?.metal_box ?? null,
							temperature_regulation:
								unitConfig.temperature_regulation ??
								r?.temperature_regulation ??
								null,
							automation:
								unitConfig.automation ?? r?.automation ?? null,
							automationSelection:
								unitConfig.automationSelection ??
								unitConfig.automation_selection ??
								r?.automationSelection ??
								r?.automation_selection ??
								[],
							reinforcement_mesh:
								unitConfig.reinforcement_mesh ??
								r?.reinforcement_mesh ??
								null,
						};
					}),

				newVersion: this.location.newVersion,
				isLocationChanged: !!this.location?.isLocationChanged,
				compartmentation: Number(this.location?.compartmentation ?? 0),
				customization: Number(this.location?.customization ?? 0),
			};

			delete payload.productDetailsData;

			try {
				const response = await apiClient.put(
					`/api/locations/update/${this.location.id}/`,
					payload
				);

				this.initialLocation = response.data;

				response.data.newVersion =
					this.location.newVersion || this.location?.newVersion;

				this.location = response.data;
				this.location.newVersion =
					this.location.newVersion || this.initialLocation.newVersion;
				this.locationId = response.data.id;
				await this.$router.replace({
					...this.$route,
					params: {
						...this.$route.params,
						locationId: this.locationId,
					},
				});
				this.savedLocation = true;

				if (!this.isSaveOfferClicked && !this.createNewOfferClicked) {
					showAlertModal(
						this.$store,
						`<b>Locația</b> a fost salvată cu succes.`,
						"success",
						3000
					);
				}

				return response.data;
			} catch (error) {
				console.log(error);
				showAlertModal(
					this.$store,
					"A apărut o eroare la salvarea locației. Vă rugăm reîncercați.",
					"danger",
					12000,
					error
				);
				return null;
			}
		},
		/**
		 * Receives child updates and toggles savedLocation like VMC does.
		 * @param {Object} newLocation
		 * @returns {void}
		 */
		onLocationUpdated(newLocation) {
			this.location = newLocation;
			if (this.savedLocation) {
				this.savedLocation = !newLocation.isLocationChanged;
			}
		},
	},
	/**
	 * Watch for changes in location.rooms and synchronize insulation fields.
	 */
	watch: {
		"location.show_apartments": {
			immediate: true,
			handler(val) {
				if (val !== undefined && val !== null) {
					this.showApartments = !!val;
				}
			},
		},

		recommendedProducts: {
			handler(codes) {
				const list = Array.isArray(codes) ? codes : [];
				if (
					list.length &&
					this.products?.length &&
					this.populateSpecialProductsFromRecommended
				) {
					this.populateSpecialProductsFromRecommended();
				}
			},
		},
		// When price list loads after composite offer (comp 1/2), ensure special products are shown
		products: {
			handler(productsList) {
				if (
					Array.isArray(productsList) &&
					productsList.length > 0 &&
					this.recommendedProducts?.length > 0 &&
					this.populateSpecialProductsFromRecommended
				) {
					this.populateSpecialProductsFromRecommended();
				}
			},
		},
		"location.rooms": {
			handler(newRooms) {
				if (!this.location) return;

				const insulationMap = this._insulationRoomMap ?? new Map();
				const productMap = this.productRoomMap ?? new Map();

				const updatedRooms = newRooms.map(room => {
					const base = this._withDerivedFields(room); //  important
					const roomId = base.localId ?? base.id;

					const existingInsulation = insulationMap.get(roomId);
					const existingProduct = productMap.get(roomId);
					const defaultInsulation = this.insulationTypes.find(
						i => i.title === "Panou cu nuturi 11mm"
					)?.value;

					const merged = {
						...room,

						// Insulation fields
						insulationType:
							room.insulationType ??
							existingInsulation?.insulationType ??
							defaultInsulation ??
							null,
						additionalInsulations: Array.isArray(
							room.additionalInsulations
						)
							? [...room.additionalInsulations]
							: Array.isArray(
										existingInsulation?.additionalInsulations
							)
								? [...existingInsulation.additionalInsulations]
								: [],
						// Product details fields
						pipe_diameter:
							existingProduct?.pipe_diameter ??
							room.pipe_diameter ??
							null,
						distributor:
							existingProduct?.distributor ??
							room.distributor ??
							null,
						metal_box:
							existingProduct?.metal_box ??
							room.metal_box ??
							null,
						temperature_regulation:
							existingProduct?.temperature_regulation ??
							room.temperature_regulation ??
							null,
						automation:
							existingProduct?.automation ??
							room.automation ??
							null,
						automationSelection:
							room.automationSelection ??
							room.automation_selection ??
							existingProduct?.automationSelection ??
							existingProduct?.automation_selection ??
							[],
						reinforcement_mesh:
							existingProduct?.reinforcement_mesh ??
							room.reinforcement_mesh ??
							null,
					};
					return this._withDerivedFields(merged);
				});

				const stringify = v => JSON.stringify(v, Object.keys(v).sort());
				const different = newRooms.some(
					(room, i) => stringify(room) !== stringify(updatedRooms[i])
				);

				if (different) {
					this.location.rooms = updatedRooms;
				}

				// Update maps
				this._insulationRoomMap = new Map();
				this.productRoomMap = new Map();

				this.location.rooms.forEach(room => {
					const id = room.localId ?? room.id;
					this._insulationRoomMap.set(id, room);
					this.productRoomMap.set(id, room);
				});
			},
			immediate: true,
			deep: true,
		},
		/**
		 * After location is saved, resume the original action:
		 * - If a new version was created and save was clicked, re-run createOffer with the new locationId.
		 * - Else continue with createSaveOffer or createOffer depending on what the user pressed.
		 */
		savedLocation: {
			handler(newVal) {
				if (!newVal) return;

				const isComposite =
					this.$options.name === "OfferIPA" &&
					(this.location?.compartmentation === 1 ||
						this.location?.compartmentation === 2);

				const isNewVersion = !!this.location?.newVersion;

				if (
					isNewVersion &&
					(this.isSaveOfferClicked || this.createNewOfferClicked)
				) {
					this.locationId =
						this.initialLocation?.id ?? this.locationId;

					this.showRecommendedThermostatWarningIfNeeded();
					if (isComposite) {
						this.saveCompositeOffer();
					} else {
						this.createOffer();
					}

					return;
				}

				if (this.isSaveOfferClicked && !isNewVersion) {
					this.showRecommendedThermostatWarningIfNeeded();
					if (!this.offerId) {
						if (isComposite) this.saveCompositeOffer();
						else this.createOffer();
						return;
					}

					if (isComposite) this.saveCompositeOffer();
					else this.saveOffer();
					return;
				}
			},
		},
	},
};
</script>

<style scoped>
::v-deep(.v-expansion-panel-text__wrapper) {
	padding: 10px !important;
}
</style>
